import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/shadcn/checkbox'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { helpKey } from '@/lib/action-modules/help'
import { isManualActionIncentivationSourceModel, type IncentivationSourceEditorProps, type ManualActionIncentivationSourceModel } from '@/lib/action-modules/registry/incentivation/types'

export default function ManualActionSourceEditor(props: IncentivationSourceEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const source = props.value
  if (!isManualActionIncentivationSourceModel(source)) return <>{t('editor.invalidValue')}</>

  const update = (patch: Partial<ManualActionIncentivationSourceModel>) =>
    props.onChanged({ ...source, ...patch })

  return (
    <div className="flex flex-col gap-3">
      <HelpLabel helpKey={helpKey('incentivationSourceCanBulkUpload')} labelClassName="flex items-center gap-2 font-normal">
        <Checkbox
          checked={source.canBulkUploadIncentivationData}
          onCheckedChange={c => update({ canBulkUploadIncentivationData: c === true })}
        />
        {t('incentivationSource.manualAction.canBulkUpload')}
      </HelpLabel>
      <HelpLabel
        helpKey={helpKey('incentivationSourceCanBeCompletedByEmployee')}
        labelClassName="flex items-center gap-2 font-normal"
      >
        <Checkbox
          checked={source.canBeCompletedByEmployeeUser}
          onCheckedChange={c => update({ canBeCompletedByEmployeeUser: c === true })}
        />
        {t('incentivationSource.manualAction.canBeCompletedByEmployee')}
      </HelpLabel>
    </div>
  )
}
